import { render, staticRenderFns } from "./process-fallback.vue?vue&type=template&id=2d77e022&scoped=true&"
import script from "./process-fallback.vue?vue&type=script&lang=js&"
export * from "./process-fallback.vue?vue&type=script&lang=js&"
import style0 from "./process-fallback.vue?vue&type=style&index=0&id=2d77e022&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d77e022",
  null
  
)

export default component.exports